import { render, staticRenderFns } from "./PhotoEditor.vue?vue&type=template&id=5ac02fd1&scoped=true"
import script from "./PhotoEditor.vue?vue&type=script&lang=js"
export * from "./PhotoEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac02fd1",
  null
  
)

export default component.exports